<template>
    <div v-if="status===0" style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%"></div>
    <div v-else-if="status===1"style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%">正在跳转支付宝...</div>
    <div v-else style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%">
        <div>出错了！</div>
    </div>
</template>

<script>
    export default {
        name: "SkipPageBlue",
        data() {
            return {
                status:0
            }
        },
        created:function () {
            this.params = this.weutil.getParams(window.location.href);

            if(this.params.uid && this.params.app_id && this.params.project_id){
                this.status = 1
                this.alipay()
            }
            else{
                this.status = -1
            }
        },
        methods:{
            payOk:function(){
                this.$router.go(-1);
            },
            alipay:function () {
                let that = this
                this.weapi.request({
                    url: 'pay/alipay/project_form_app',
                    method: 'get',
                    params: {
                        app_id: this.params.app_id,
                        project_id: this.params.project_id,
                        uid:this.params.uid,
                        redirect_url:window.location.href
                    },
                }).then(res => {
                    if (res.status === 200) {
                        const div = document.createElement('div')
                        /* 此处form就是后台返回接收到的数据 */
                        div.innerHTML = res.data
                        document.body.appendChild(div)
                        document.forms[0].submit()
                    }
                    else if(res.status === 202){
                        that.$toast(res.data);
                    }
                    else {

                    }
                }).catch(function (error) {
                    console.log(error)
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })

            }
        }
    }
</script>

<style scoped>

</style>
